export const copilot = {
variant: {
recommendation: "توصية",
action: "إجراء جاهز",
insight: "رؤية",
},
dismiss: {
accessibilityLabel: "تجاهل الاقتراح",
},
rationale: {
label: "لماذا هذا",
skillLabel: "لماذا هذه المهارة",
riskLabel: "لماذا مستوى الخطورة هذا",
notProvided: "لم يقدّم النموذج تفسيرًا.",
},
followUp: {
kicker: "الذكاء الاصطناعي يُعِدّ مسودة…",
loadingCaption: "يحدّد المهارة والخطورة والإلحاح المناسبين من ملاحظات هذا العنصر.",
successKicker: "اقتراح الذكاء الاصطناعي جاهز",
idleBodyWithAsset: "يمكن للذكاء الاصطناعي إعداد مسودة أمر عمل متابعة لهذا العنصر على {{assetName}} — يحدد المهارة والخطورة والإلحاح المناسبين قبل أن تقبله.",
idleBodyNoAsset: "يمكن للذكاء الاصطناعي إعداد مسودة أمر عمل متابعة لهذا العنصر — يحدد المهارة والخطورة والإلحاح المناسبين قبل أن تقبله.",
suggestCta_zero: "اقترح بالذكاء الاصطناعي · {{count}} رصيد",
suggestCta_one: "اقترح بالذكاء الاصطناعي · رصيد واحد",
suggestCta_two: "اقترح بالذكاء الاصطناعي · رصيدان",
suggestCta_few: "اقترح بالذكاء الاصطناعي · {{count}} أرصدة",
suggestCta_many: "اقترح بالذكاء الاصطناعي · {{count}} رصيدًا",
suggestCta_other: "اقترح بالذكاء الاصطناعي · {{count}} رصيد",
createCta: "إنشاء متابعة",
whyExpand: "لماذا هذا؟",
whyCollapse: "إخفاء السبب",
discard: "تجاهل",
errorFallback: "تعذّر على الذكاء الاصطناعي تحليل هذا العنصر.",
fallbackCta: "إنشاء مسودة يدويًا",
skillNotMatched: "لم تُطابَق المهارة",
skillNotInCatalogWarning: "اقترح الذكاء الاصطناعي مهارة غير موجودة في كتالوجك. اختر واحدة يدويًا في الشاشة التالية.",
},
riskLabel: {
low: "خطورة منخفضة",
medium: "خطورة متوسطة",
high: "خطورة مرتفعة",
critical: "خطورة حرجة",
},
urgencyLabel: {
standard: "عادي",
priority: "ذو أولوية",
urgent: "عاجل",
},
confidence: {
high: "ثقة مرتفعة",
medium: "ثقة متوسطة",
low: "تحقق قبل القبول",
},
dock: {
openAssistant: "فتح المساعد",
expandAssistant: "قم بتوسيع المساعد",
assistantTitle: "المساعد",
closeAssistant: "إغلاق المساعد",
loadingConversation: "جارٍ تحميل المحادثة...",
assistantEmptyTitle: "اسأل المساعد",
assistantEmptyBody: "استخدم نفس المساعد التشغيلي من داخل هذه اللوحة الجانبية.",
actorYou: "أنت",
actorAssistant: "المساعد",
dictationInserting: "جارٍ إدراج النص…",
dictationFinishing: "جارٍ إنهاء الإملاء…",
dictationHeard: "ما سُمع: {{transcript}}",
dictationListening: "جارٍ الاستماع…",
messageInputLabel: "قم بمراسلة المساعد",
messagePlaceholder: "اطرح سؤالاً أو أخبر المساعد بما يجب عليه فعله",
stopDictation: "إيقاف الإملاء الصوتي",
dictateMessage: "إملاء الرسالة",
startNewThread: "ابدأ موضوع مساعد جديد",
newThread: "موضوع جديد",
sendAssistantMessage: "إرسال رسالة مساعد",
sending: "جارٍ الإرسال...",
send: "إرسال",
noSuggestionsWithAsk: "لا توجد اقتراحات في الوقت الحالي. اسأل المساعد أدناه.",
noSuggestions: "لا توجد اقتراحات في الوقت الحالي.",
openAssistantInput: "فتح إدخال المساعد",
askPlaceholder: "اسأل المساعد…",
dictateAssistantMessage: "إملاء رسالة المساعد",
},
photoFixSuggestion: {
idleHeaderText: "استخدم الصورة لصياغة إصلاح",
idleHint: "ينظر الذكاء الاصطناعي إلى الصورة وملاحظات المفتش لاقتراح العنوان والنطاق والأولوية والتكلفة التقريبية.",
suggestA11y_one: "اقتراح الإصلاح من الصورة. يكلف رصيدًا واحدًا.",
suggestA11y_other: "اقتراح الإصلاح من الصورة. يكلف {{count}} رصيد.",
suggestButton_one: "اقتراح الإصلاح من الصورة (رصيد واحد)",
suggestButton_other: "اقتراح الإصلاح من الصورة ({{count}} رصيد)",
loadingStage1: "قراءة الصورة...",
loadingStage2: "اكتشاف الخطأ المحتمل...",
loadingStage3: "صياغة الإصلاح...",
loadingStage4: "أوشكنا على الانتهاء…",
loadingHint: "يستغرق النظر إلى الصورة بضع ثوانٍ - ويمكنك الاستمرار في العمل.",
retryA11y: "إعادة محاولة اقتراح الإصلاح",
tryAgain: "إعادة المحاولة",
headerEyebrow: "توصية إصلاح بالذكاء الاصطناعي · ثقة {{pct}}٪",
priorityHigh: "مرتفعة",
priorityMedium: "متوسطة",
priorityLow: "منخفضة",
priorityChip: "أولوية {{level}}",
safetyCallouts: "تنبيهات السلامة",
useThisFixA11y: "استخدم هذا الإصلاح كمسودة أمر العمل",
useThisFix: "استخدم هذا الإصلاح",
discardA11y: "تجاهل هذا الاقتراح",
discard: "تجاهل",
suggestA11y_zero: "اقتراح الإصلاح من الصورة. بلا تكلفة.",
suggestA11y_two: "اقتراح الإصلاح من الصورة. يكلف رصيدين.",
suggestA11y_few: "اقتراح الإصلاح من الصورة. يكلف {{count}} أرصدة.",
suggestA11y_many: "اقتراح الإصلاح من الصورة. يكلف {{count}} رصيدًا.",
suggestButton_zero: "اقتراح الإصلاح من الصورة (بلا رصيد)",
suggestButton_two: "اقتراح الإصلاح من الصورة (رصيدان)",
suggestButton_few: "اقتراح الإصلاح من الصورة ({{count}} أرصدة)",
suggestButton_many: "اقتراح الإصلاح من الصورة ({{count}} رصيدًا)",
},
};
